import React, { useEffect } from 'react'
import TrendingStoreBnner from '../../../../../../../public/assets/img/trendingStore.svg'
import MobileTrendingStoreBnner from '../../../../../../../public/assets/img/mobileTrendingStore.svg'
import { WOMEN_SECTION_TEXT } from 'src/Helpers/Json/WomanCategoryList'
import { useMutation } from '@apollo/client'
import { useAppDispatch } from 'src/store/store'
import { useRouter } from 'next/router'
import { fetchApplianceCategory } from 'src/store/slices/manageApplianceCategorySlice'
import { guestAccountDetailSlice } from 'src/store/slices/guestAccountDetailSlice'
import { useAuth } from 'src/utils/auth'
import { notification } from 'antd'
import FOLLOW_STORE from 'src/graphql/mutations/followStore'
import UNFOLLOW_STORE from 'src/graphql/mutations/unFollowStore'
import NewStoreSlider from 'src/components/StoreAndProductDetailModal/StoresModal/NewStoreSlider'
import { fetchStoreByCategory } from 'src/store/slices/fetchAllStoresSlice'
import { useSelector } from 'react-redux'

export default function TrendingStore(props) {
  const router = useRouter()
  const { user }: any = useAuth()
  const categoryStore = useSelector((state: any) => state?.storesData?.categoryStore)
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(fetchStoreByCategory({ category_id: [35], subCategory_id: [18], page: 1, limit: 10 }))
  }, [])

  const [followStore] = useMutation(FOLLOW_STORE, {
    onCompleted: (res) => {
      dispatch(fetchStoreByCategory({ category_id: [35], subCategory_id: [18], page: 1, limit: 10 }))
    },
    onError: (err) => {
      notification['error']({
        message: 'Error',
        description: 'Something went wrong',
      })
    },
  })

  const [unfollowStore] = useMutation(UNFOLLOW_STORE, {
    onCompleted: (res) => {
      dispatch(fetchStoreByCategory({ category_id: [35], subCategory_id: [18], page: 1, limit: 10 }))
    },
    onError: (err) => {
      notification['error']({
        message: 'Error',
        description: 'Something went wrong',
      })
    },
  })

  const followStoreCall = (store) => {
    if (user) {
      followStore({
        variables: { store_id: store.id },
      })
    } else {
      handleRedirect()
    }
  }

  const unfollowStoreCall = (store) => {
    if (user) {
      unfollowStore({
        variables: { storeId: store.id },
      })
    } else {
      handleRedirect()
    }
  }

  const handleRedirect = () => {
    dispatch(
      guestAccountDetailSlice({
        modal: 'authModal',
        isOpen: true,
        id: {
          media: 'https://storage.googleapis.com/bluejestic-media/bluejestic-stage/loginmedia/Live-Shopping-Short.mp4',
          modalFor: 'login',
          startWith: 'loginModal',
        },
      }),
    )
  }

  const handleAddStoreLike = () => {}

  return (
    <div className="trendingStore-section">
      <div className="trendingStore-main-banner">
        <div className="trendingStore-back-alignment">
          <div
            className="back_details-alignment"
            onClick={() => {
              router.push('/fashion/women/', undefined, { scroll: false })
              dispatch(fetchApplianceCategory({ modal: '', isOpen: false, id: 0 }))
            }}
          >
            <div>
              <img src="/assets/icon/left-icon.svg" alt="back-page" />
            </div>
            <p>Woma...</p>
          </div>
          <div className="mobile-heading-alignment">
            <h4>Trending Store</h4>
          </div>
        </div>
        <div className="trendingStore-banner">
          <div className="trending-banner-img-alignment">
            <img src={TrendingStoreBnner.src} alt="TrendingStoreBnner" />
            <img src={MobileTrendingStoreBnner.src} alt="MobileTrendingStoreBnner" className="mobile-view-banner" />
          </div>
          <div className="container">
            {/* <div className="trendingStore-small-banner-alignment">
            <div className="trendingStore-banner-section">
              <div onClick={() => PageDataFun('WomansCategory')}>
                <img src="/assets/icon/leftArrow.svg" alt="left-arrow" />
              </div>
            </div>
            <div className="trendingStore-heading-alignment">
              <h4>Trending Store</h4>
            </div>
          </div> */}
            <div className="trendingStore-banner-section">
              <div
                className="left-arrow-alignment"
                onClick={() => {
                  router.push('/fashion/women/', undefined, { scroll: false })
                  dispatch(fetchApplianceCategory({ modal: '', isOpen: false, id: 0 }))
                }}
              >
                <img src="/assets/icon/leftArrow.svg" alt="left-arrow" />
              </div>
              <div className="trendingStore-heading-alignment">
                <h4>Trending Store</h4>
                <p>{WOMEN_SECTION_TEXT.trending_store.text}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="trending-store-alignment">
        <div className="container">
          <div className={'popularStoreDetailsGridView'}>
            {categoryStore?.map((store, index) => {
              return (
                <React.Fragment key={index}>
                  <NewStoreSlider
                    store={store}
                    followStoreCall={followStoreCall}
                    unfollowStoreCall={unfollowStoreCall}
                    handleAddStoreLike={handleAddStoreLike}
                  />
                </React.Fragment>
              )
            })}
          </div>
        </div>
      </div>
    </div>
  )
}
